import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router";
import FBillContainer from "../../components/FBillContainer/FBillContainer";
import { v4 as uuidv4 } from "uuid";
import { useProcessor } from "../../hooks/useProcessor";
import { array } from "i/lib/util";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { useRegex } from "../../hooks/useRegex";
import { useSpendFiado } from "../../hooks/useSpendFiado";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";
import FInputt from "../../components/FInputt/FInputt";
import { useFormik } from "formik";
import FNavigator from "../../components/FNavigator/FNavigator";
import { AuthContext } from "../../context/AuthContext";
import Switch from "react-switch";
import Swal from "sweetalert2";
import { useHome } from "../Home/hooks/useHome";


const BillScreen2 = ({ param }) => {
  const { saldo, textSaldo, _getBalance } = useHome();

  const { createBill, products, details, processPayment } = useProcessor();
  const { process } = useSpendFiado();
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const { checkToken } = useContext(AuthContext);

  const { sendToFinalScreen } = useBillPaymentArcus();
  const { formatWithCurrencyISO } = useCurrencyFormat();
  const [productDescription, setProductDescription] = useState("");
  const [favorite, setFavorite] = useState(false);

  const { description } = useRegex();

  const { state } = useLocation();
  const route = useNavigate();

  useEffect(() => {
    _getBalance();
    if (state == null) {
      route("/");
    } else {
      setIdempotencyKey(uuidv4());
      //console.log(comeFromFavorites)
      createBill(state.data);
    }
  }, []);

  useEffect(() => {
    // console.log(products[0].commissions);
    formatWithCurrencyISO(parseFloat(details?.grandTotal), "484");
  });

  const nextScreen = async (
    data,
    originCurrencyId,
    destinationCurrencyId,
    idempotencyKey
  ) => {
    if (data.products[0].amount <= saldo) {
      checkToken()
      try {
        let resp = await process(
          data,
          originCurrencyId,
          destinationCurrencyId,
          idempotencyKey
        );

        if (resp.data.code == "PROCESS_OK") {
          const next = () => {
            route("/MovementScreen")
            // route("/PaymentDetailScreen", {
            //   state: { transactionId: resp.data.data.transactionNumber },
            // });
          };

          Swal.fire({
            showCloseButton: true,
            title: 'Éxito',
            text: "Se ha confirmado el pago exitosamente.",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            // iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          }).then((result) => {
            if (result.isConfirmed) {
              next();
            } else {
              next();
            }
          })

        }
      } catch (error) {
      }
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Fondos insuficiente',
        text: "¿Quieres pedir un fiado?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Si quiero pedir uno'
      }).then((result) => {
        if (result.isConfirmed) {
          route("/ShareFiadoScreen")
        }
      });
    }
  };

  const addToFavorites = async () => {
    console.log(favorite);
    if (favorite == true) {
      formikBillScreen.setFieldValue("saveAsFavorite", false);
      setFavorite(false);
    } else {
      formikBillScreen.setFieldValue("saveAsFavorite", true);
      setFavorite(true);
    }
  };

  const formikBillScreen = useFormik({
    initialValues: {
      saveAsFavorite: false,
      description: "",
    },
    onSubmit: async (values) => {

      if (state.backScreen == "CashoutBank") {
        let response = await processPayment(state.data, state.idempotencyKey);

        if (response?.data?.code == "PROCESS_OK") {
          //setModalQuestionVisible(false)
          const next = () => { }
          Swal.fire({
            showCloseButton: true,
            title: 'Éxito',
            text: 'La transferencia se realizó correctamente',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            // iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          }).then((result) => {
            if (result.isConfirmed) {
              route("/MovementScreen");
            } else {
              route("/MovementScreen");
            }
          })
        }
        else if (response?.data?.code == "INVALID_ACCOUNT_NUMBER") {
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: 'número de cuenta inválido',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
          //setModalQuestionVisible(false)
        }
        else if (response?.data?.code == "YOU_REQUEST_CANNOT_BE_PROCESSED_AT_THIS_TIME") {
          //setModalQuestionVisible(false)
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: 'Su solicitud no puede ser procesada',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        } else {
          //setModalQuestionVisible(false)
          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: 'No pudimos procesar tu solicitud en este momento, por favor intenta mas tarde',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        }
      } else {
        const { saveAsFavorite, description } = values;
        state.data.products[0].saveAsFavorite = saveAsFavorite;
        state.data.products[0].description = description;
        nextScreen(
          state.data,
          state.data.originCurrencyId.toString(),
          state.data.destinationCurrencyId.toString(),
          idempotencyKey
        );
      }

    },



    validate: (values) => {
      const errors = {};
      return errors;
    },
  });

  const FormSetFavorite = () => {
    return (
      <>
        {state.comeFromFavorites != true ? (
          <div className="flex flex-col justify-center mt-5">
            <div className="text-center">Guardar en favoritos</div>
            <div className="justify-center flex mt-2">
              <Switch
                onColor="#F10C8F"
                onChange={() => {
                  addToFavorites();
                }}
                checked={favorite}
              />
            </div>
            <div className={`mt-2 ${favorite == true ? "block" : "hidden"}`}>
              <FInputt
                type="text"
                name="description"
                title={"Concepto"}
                formik={formikBillScreen}
                placeholder={"¿Cómo te gustaría recordar este servicio?"}
              />
            </div>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <>
      {state != null ? (
        <>
          <div className="w-full grid place-items-center mb-20">
            <form
              onSubmit={formikBillScreen.handleSubmit}
              className="border-0 w-full xs:px-10 sm:w-[500px]"
            >
              <div className=" text-center font-bold text-[5vw] xxs:text-[22px] py-3">
                Confirma tu pago
              </div>
              <FBillContainer
                disabledButton={false}
                originCurrencyId={state.data.originCurrencyId}
                total={formatWithCurrencyISO(
                  details.grandTotal,
                  state.data.originCurrencyId
                )}
                component={FormSetFavorite}
                btnTitle="Continuar"
                products={products}
                btnOnChange={
                  formikBillScreen.handleSubmit
                  //nextScreen(state.data,state.data.originCurrencyId,state.data.destinationCurrencyId,idempotencyKey)
                }
              />
            </form>
          </div>
        </>
      ) : (
        route("/")
      )}
    </>
  );
};

export default BillScreen2;
